import { CommApiInstance } from "Utils/CommApiInstance";




const MembMktgAgreInqApi = async (

) => {
    return await CommApiInstance.post("memb/mktg",{
        apiBody:{

        },
    })
    .then((Resp) => Resp.data);
}
export default MembMktgAgreInqApi;